$(function() {

    if (commentsDetect()) scrollToComments();


    $('.comments-container .list-title').on('click', function(event) {
        var parent = $(this).parents('.comments-container');

        parent.find('.list-container').slideToggle(animateSpeed);
        $(this).toggleClass('closed');
    });


    $('.comments-container .comment-item .button-reply').on('click', function(event) {
        var container = $(this).parents('.comments-container'),
            parent = $(this).parents('.comment-item-container').eq(0),
            parentId = parent.data('id'),
            name = parent.find('.name').eq(0).html(),
            date = parent.find('.date').eq(0).html(),
            writeContainer = container.find('.write-comment-container'),
            top = writeContainer.offset().top;

        writeContainer.find('.reply-container .reply').html(name);
        writeContainer.find('.reply-container .date').html(date);
        writeContainer.find('form.comment-form input[name="comment_id"]').val(parentId);
        writeContainer.find('.reply-container').addClass('active');

        $('body, html').animate({scrollTop: top - 40}, animateSpeed, 'linear');
    });


    $('.write-comment-container .reply-container .cancel').on('click', function(event) {
        var container = $(this).parents('.write-comment-container'),
            form = container.find('.comment-form');

        container.find('.reply-container').removeClass('active').find('.reply, .date').html('');
        form.find('input[name="comment_id"]').val('');
    });


    $('.comments-container .comment-item .button-delete').on('click', function(event) {
        var container = $(this).parents('.comments-container'),
            parentId = $(this).parents('.comment-item-container').eq(0).data('id'),
            form = container.find('.comment-form');

        form.find('input[name="comment_id"]').val(parentId);
        form.find('input[name="action"]').val('delete');

	    form.submit();
    });


    $('.comment-form .submit-form').on('click', function(event) {
        var form = $(this).parents('.comment-form');

        form.find('input[name="action"]').val('add');
	    if (validateFormFields(form)) ajaxSendComment(form);
    });

});


// Проверка наличия блока с комментариями на странице
function commentsDetect() {
    return $('.comments-container').length > 0 ? true : false;
}


// Скролит страницу до комментариев
function scrollToComments() {	
    var hash = window.location.hash.substr(1),
        regExp = /^comment\d+$/,
        offsetTop;

    if (hash && (hash === 'comments' || regExp.test(hash))) {
        if (hash === 'comments') offsetTop = $('.comments-container').offset().top;
        else if (regExp.test(hash)) {
            var jqComment = $('.comment-item-container[data-id="' + /\d{1,}$/.exec(hash)[0] + '"]');

            if (jqComment.length > 0) offsetTop = jqComment.offset().top;
        }

        $('body, html').animate({scrollTop: offsetTop - 40}, 1, 'linear');
    }
}